import type { LinkedinAccountStatus } from '@/types/models'

export const linkedinAccountStatusLabels: Record<LinkedinAccountStatus, string> = {
  connecting: 'Connecting',
  checkpoint_required: 'Checkpoint required',
  connected: 'Connected',
  disconnected: 'Disconnected',
  credentials_expired: 'Credentials expired',
  account_restricted: 'Account restricted',
  error: 'Error',
}
